"use client";
import { createContext, createElement } from "react";
const WidthCapContext = createContext(void 0);
function WidthCapProvider({ value, children }) {
    return createElement(WidthCapContext.Provider, {
        value
    }, children);
}
export { WidthCapContext, WidthCapProvider };
